export enum TokenType {
    Aad,
    Embed
}